// components/layout/navigation-simple.jsx
'use client';

import Link from 'next/link';
import { usePathname } from 'next/navigation';
import { useMemo } from 'react';
import { mainNav } from '@/content/navigation';
import ServicesDropdown from '@/components/layout/services-dropdown';

export default function NavigationSimple({
    isMobile = false,
    onLinkClick,
    fixedCss,
    megaMenuClassName = '',
    variant = 'dark', // 'light' | 'dark'
}) {
    const pathname = usePathname();
    const hiddenLinksByPath = ['/if-lp-page'];

    const isLight = variant === 'light';

    const styles = useMemo(() => {
        const textColor = isLight ? 'text-white' : 'text-white';
        const hoverTextColor = isLight ? 'hover:text-white/80' : 'hover:text-white/80';
        return { textColor, hoverTextColor };
    }, [isLight]);

    // helper: prevents accidental // in href
    const safeHref = (href) => (href?.startsWith('/') ? href : `/${href}`);

    if (hiddenLinksByPath.includes(pathname)) return null;

    return (
        <nav
            className={`${
                isMobile
                    ? 'flex flex-col space-y-5 px-6 pt-6 text-lg scrollbar'
                    : `flex items-center space-x-18 fs-18 relative ${styles.textColor}`
            } ${fixedCss || ''}`}
        >
            {mainNav.map(({ label, href }) => {
                if (label === 'Services') {
                    return (
                        <ServicesDropdown
                            key="Services"
                            isMobile={isMobile}
                            variant={variant}
                            megaMenuClassName={megaMenuClassName}
                            onLinkClick={onLinkClick}
                        />
                    );
                }

                return (
                    <Link
                        key={label}
                        href={safeHref(href)}
                        className={`cursor-pointer transition-colors duration-300 hover:underline ${styles.textColor} ${styles.hoverTextColor}`}
                        onClick={onLinkClick}
                    >
                        {label}
                    </Link>
                );
            })}

            {isMobile ? <div>{/* Mobile buttons placeholder */}</div> : null}
        </nav>
    );
}
